import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { RESTSERVICE } from 'src/app/core/enum/restService.enum';
import { environment } from 'src/environments/environment';
import { IGeneralText } from 'src/app/core/interfaces/generalText.interface';
import { TextService } from 'src/app/core/service/text.service';
import { RequestService } from '../../../core/service/request.service';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-excel-upload-form',
  templateUrl: './excel-upload-form.component.html',
  styleUrls: ['./excel-upload-form.component.scss'],
})
export class ExcelUploadFormComponent implements OnInit {
  @Input() uniqueId;
  @Input() config;
  @Input() visible;
  @Output() onToggle = new EventEmitter();
  @Output() onImport = new EventEmitter();
  excelForm: FormGroup;
  generalTexts: IGeneralText = {
    uploadSuccess: { labelId: 'L_SUCCESS_UPLOADED' },
    uploadError: { labelId: 'L_RECORD_CREATE_ERROR' },
    uploadMsg: { labelId: 'L_ERROR_TITLE' },
    successfulMsg: { labelId: 'L_SUCCESSFUL' },
    cancelBtn: { labelId: 'L_CANCEL' },
    uploadBtn: { labelId: 'L_UPLOAD' },
    chooseBtn: { labelId: 'L_CHOOSE' },
    title: { labelId: 'L_UPLOAD_XLS' },
  };

  mimeTypes = {
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  };

  constructor(
    private messageService: MessageService,
    private textService: TextService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.excelForm = new FormGroup({
      file: new FormControl(null, Validators.required),
    });
    this.textService
      .convert({ generalTexts: this.generalTexts })
      .subscribe((converted) => {
        this.generalTexts = converted.generalTexts;
      });
  }
  get uploadUrl() {
    return environment.apiUrl + '' + this.config['excel'].uploadUrl;
  }
  hideDialog(): void {
    this.visible = false;
    this.onToggle.emit({ visible: false });
  }
  onFileUpload(e) {
    this.excelForm.get('file').setValue(e.target.files[0]);
  }
  onUpload() {
    this.messageService.clear(`base-table-${this.uniqueId}`);
    this.messageService.add({
      severity: RESTSERVICE.SUCCESS,
      summary: this.generalTexts.successfulMsg.label,
      detail: this.generalTexts.uploadSuccess.label,
      life: 3000,
      key: `base-table-${this.uniqueId}`,
    });
    this.hideDialog();
    this.onImport.emit();
  }

  uploadManually(evnt) {
    const formData = new FormData();
    formData.append('file', evnt.files[0]);

    this.http
      .request('POST', this.uploadUrl, {
        body: formData,
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (resp) => {
          const filename = resp.headers.get('x-autobcmapp-params');
          const element = document.createElement('a');
          document.body.appendChild(element);
          element.href = window.URL.createObjectURL(resp.body);
          element.download = filename;
          element.click();
        },
        error: (err) => {
          this.hideDialog();
          this.messageService.clear(`base-table-${this.uniqueId}`);
          this.messageService.add({
            severity: RESTSERVICE.ERROR,
            summary: this.generalTexts.uploadMsg.label,
            detail: this.generalTexts.uploadError.label,
            life: 3000,
            key: `base-table-${this.uniqueId}`,
          });
        },
        complete: () => {
          this.onUpload();
        },
      });
  }
}
